import { useQueryHubsResourceReport } from '../api';

export const useHubDetails = (id: string | null) => {
  const { data: hubs } = useQueryHubsResourceReport();

  const hub = hubs.find(hub => hub.id === id) ?? null;
  return {
    resources: hub?.staffInfo ?? [],
    location: hub?.location,
  };
};
